import React from "react";
import { useLocation } from "react-router-dom";
import { useState, useEffect, useContext } from "react";
import { Box, Container, Divider, IconButton, TextField } from "@mui/material";
import { ColorModeContext, useMode } from "../theme";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { Topbar } from "../layouts/Topbar";
import { tokens } from "../theme";
import Sidebarr from "../layouts/Sidebar";
import Header from "../components/Header";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import AuthContext from "../auth/AuthProvider";
import Typography from "@mui/material/Typography";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import KeyboardDoubleArrowDownIcon from "@mui/icons-material/KeyboardDoubleArrowDown";
import { Button } from "@mui/material";
import {
  DataGrid,
  GridToolbar,
  GridRowParams,
  GridActionsCellItem,
} from "@mui/x-data-grid";
import LaunchOutlinedIcon from "@mui/icons-material/LaunchOutlined";
import { useNavigate } from "react-router-dom";
import { fetchToken, fetchRole } from "../auth/Token";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import { api } from "../api";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import CancelIcon from "@mui/icons-material/Cancel";
import CloseIcon from "@mui/icons-material/Close";
import Snackbar from "@mui/material/Snackbar";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "sonner";

export const OneKindAssociation = () => {
  const [theme, colorMode] = useMode();
  const location = useLocation();
  const navigate = useNavigate();
  const { permissions } = useContext(AuthContext);
  const responseInfo = location.state && location.state.responseInfo;
  const society_id = location.state && location.state.society_id;
  const [name, setMename] = useState(
    responseInfo?.association_type_info[0]?.association_type
  );
  const [kindName, setKindName] = useState(name);
  const [updateName, setUpdateName] = useState(false);

  // console.log(responseInfo);
  const columns = [
    {
      field: "association_id",
      headerName: "ID",
      flex: 1,
      cellClassName: "name-column--cell",
    },
    {
      field: "association_name",
      headerName: `${responseInfo?.association_type_info[0]?.association_type}  Name`,
      flex: 1,
      cellClassName: "name-column--cell",
    },
    {
      field: "community_name",
      headerName: "Community",
      flex: 1,
    },
    {
      field: "open_date",
      headerName: "Date Created",
      flex: 1,
    },
    {
      field: "actions",
      type: "actions",
      getActions: (params: GridRowParams) => [
        <GridActionsCellItem
          icon={<LaunchOutlinedIcon />}
          onClick={() => handleClick(params.row.association_id)}
          label="Open"
        />,
      ],
    },
  ];

  const handleClick = (associationId) => {
    try {
      api
        .get(`association/${associationId}`, {
          headers: {
            Authorization: "Bearer " + fetchToken(),
          },
        })
        .then(function (response) {
          navigate("/association/", { state: { responseData: response.data } });
        })
        .catch(function (error) {
          console.log(error);
        });
    } catch (error) {
      console.log("This is that error", error);
    }
  };

  const handleYou = (id) => {
    navigate("/association/create", { state: { associationType_id: id } });
  };

  const sesano = () => {
    const data = new FormData();
    data.append(
      "associationKind_id",
      responseInfo?.association_type_info[0]?.associationtype_id
    );
    data.append("new_name", kindName);
    api
      .post("/association/update/kind", data, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        toast.success(response.data);
      })
      .finally(function () {
        setUpdateName(false);
      });
  };

  if (responseInfo) {
    return (
      <div className="app">
        <main className="content">
          <Box sx={{ m: 5 }}>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <Header
                title={responseInfo?.association_type_info[0]?.association_type}
                subtitle="Explore"
              />
            </Box>

            <Card sx={{ minWidth: 480, margin: 4, justifyContent: "center" }}>
              <CardContent sx={{ justifyContent: "center" }}>
                <IconButton onClick={() => setUpdateName(true)}>
                  <ModeEditIcon />
                </IconButton>
                {updateName === true ? (
                  <>
                    <TextField
                      sx={{ textAlign: "center", ml: 28 }}
                      size="small"
                      value={kindName}
                      onChange={(e) => setKindName(e.target.value)}
                      variant="outlined"
                      label="Society Name"
                    />
                    <IconButton onClick={sesano} sx={{ mb: 2 }}>
                      <SaveOutlinedIcon />
                    </IconButton>
                    <IconButton
                      onClick={() => setUpdateName(false)}
                      sx={{ mb: 2, ml: 1 }}
                    >
                      <CancelIcon />
                    </IconButton>
                  </>
                ) : (
                  <Typography
                    gutterBottom
                    variant="h3"
                    sx={{ marginLeft: 65, fontWeight: "bolder" }}
                    component="div"
                  >
                    {responseInfo?.association_type_info[0]?.association_type}
                  </Typography>
                )}
                <Typography
                  sx={{ fontSize: 14 }}
                  color="text.secondary"
                  gutterBottom
                >
                  <Accordion>
                    <AccordionSummary
                      expandIcon={<KeyboardDoubleArrowDownIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                    >
                      <Typography sx={{ marginLeft: 60 }}>
                        See More Details
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography sx={{ marginLeft: 40 }}>
                        {responseInfo?.association_type_info[0]?.accepted_forms ===
                        "Cash"
                          ? "All Savings Groups Registered under " +
                            responseInfo?.association_type_info[0]
                              ?.association_type +
                            " accepts only cash for business"
                          : responseInfo?.association_type_info[0]
                              ?.accepted_forms === "Commodities"
                          ? "All Savings Groups Registered under " +
                            responseInfo?.association_type_info[0]
                              ?.association_type +
                            " accepts only comodities for business"
                          : responseInfo?.association_type_info[0]
                              ?.accepted_forms === "Both"
                          ? "All Savings Groups Registered under " +
                            responseInfo?.association_type_info[0]
                              ?.association_type +
                            " takes both cash and comodities for business"
                          : "All Savings Groups Registered under " +
                            responseInfo?.association_type_info[0]
                              ?.association_type +
                            " takes " +
                            responseInfo?.association_type_info[0]
                              ?.accepted_forms +
                            " for business"}
                      </Typography>
                    </AccordionDetails>
                  </Accordion>
                  <Container>
                    {permissions && permissions.create_association === true ? (
                      <Button
                        onClick={() =>
                          handleYou(
                            responseInfo?.association_type_info[0]
                              ?.associationtype_id
                          )
                        }
                        variant="contained"
                        color="success"
                        sx={{ marginTop: 3 }}
                      >
                        Register Savings Group
                      </Button>
                    ) : null}
                  </Container>
                </Typography>
              </CardContent>
            </Card>
            <Divider variant="middle" />
            <Box m="40px 0 0 0" height="75vh" paddingBottom="35px">
              <DataGrid
                rows={responseInfo?.associations_of_type}
                columns={columns}
                checkboxSelection
                getRowId={(row) => row.association_id}
                slots={{ toolbar: GridToolbar }}
              />
            </Box>
          </Box>
        </main>
      </div>
    );
  } else {
    return (
      <div className="app">
        <main className="content">
          <Box sx={{ m: 5 }}>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <Header title="Opps" subtitle="No Data was Found" />
            </Box>
          </Box>
        </main>
      </div>
    );
  }
};
